import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { IntegrationCard, SectionHeader, TextButtonAccordion } from 'components';
import { theme, toRem } from 'design';
import { getIntegrationAppsRequest, selectIntegrationApps } from 'store/Collections/Integrations';
import { IPOSIntegration } from 'types';

const Section = styled.section`
  display: flex;
  flex-flow: column nowrap;
  background-color: ${theme.color.neutral[50]};
  border: 1px solid ${theme.color.neutral[200]};
  border-radius: ${toRem(5.5)};
  padding: ${toRem(theme.space.lg)};

  &:not(:last-child),
  > div:not(:last-child) {
    margin-bottom: ${toRem(theme.space.lg)};
  }
`;

interface IPosIntegrationsSettingsProps {
  integrations?: IPOSIntegration[];
}

const PosIntegrationsSettings = ({ integrations }: IPosIntegrationsSettingsProps) => {
  const dispatch = useDispatch();
  const apps = useSelector(selectIntegrationApps);
  const hasIntegrations = Boolean(integrations?.length);

  React.useEffect(() => {
    // Resolve setting names/values from the catalog (fetch-once; saga serves from cache).
    if (hasIntegrations) dispatch(getIntegrationAppsRequest());
  }, [dispatch, hasIntegrations]);

  if (!hasIntegrations) return null;

  return (
    <Section data-cy="pos-integrations-settings">
      <SectionHeader title="Integrations" />
      <TextButtonAccordion title="POS Integrations Settings" buttonText="Settings">
        {integrations.map((integration) => (
          <IntegrationCard key={integration.integrationId} integration={integration} apps={apps} hideToggle />
        ))}
      </TextButtonAccordion>
    </Section>
  );
};

export default PosIntegrationsSettings;
